<template>
    <nav>

        <MenuVoteComment v-if="showNowPlayingCommentModal" @close="showNowPlayingCommentModal = false"  @saveComment="saveComment" @deleteComment="deleteComment" :isTpg="isTpg" :voteReasons="voteReasons" :track="nowPlayingTrackWithVote" :oldComment="nowPlayingTrackWithVote.votes.comment" :oldReason="nowPlayingTrackWithVote.votes.voteReasonId"
            :vote="nowPlayingTrackWithVote.votes.vote"></MenuVoteComment>

        <SelectCustomMix v-if="showMixModal" @close="showMixModal = false" ref="selectMixModal" @newMixSelected="newMixSelected" :selectedMix="selectedMix" :customMixes="customMixes" :resetMixModal="resetMixModal" :isLoading="isLoading" :canShuffleOnPlayer="canShuffleOnPlayer" :isTpg="isTpg" :isVp="isVp" :showReturnToDailyButton="showReturnToDailyButton">
        </SelectCustomMix>

        <div class="overlay" :class="{ isLoading : isLoading }">
            <div class="modal-dialog">
                <div class="tent">
                    <p>{{loadingOverlayText}}</p>
                    <div class="spinner">
                        <div class="rect1"></div>
                        <div class="rect2"></div>
                        <div class="rect3"></div>
                        <div class="rect4"></div>
                        <div class="rect5"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="menu-left" v-if="userHasOnlinePlayer" :class="{noOnlinePlayers: !userHasOnlinePlayer, isTpg:isTpg}" style>

            <div class="see-whats-playing-container menu-item" :class="{isTpg:isTpg}">
                <div class="menu-item-left left-menu-item-header" style="margin-bottom:-5px;">
                    Select Player
                </div>

                <ChangePlayer v-if="userHasOnlinePlayer" :selectedPlayer="selectedPlayer" :players="players" :isTpg="isTpg" @changePlayerClicked="updateSelectedPlayer">
                </ChangePlayer>
                </div>
                <div class="see-whats-playing-container menu-item" :class="{isTpg:isTpg}">
                <div class="menu-item-left left-menu-item-header" style="margin-bottom:-5px;">
                    Currently Playing
                </div>
                <NowPlaying v-if="userHasOnlinePlayer" :selectedPlayer="selectedPlayer" :user-info="userInfo" :nowPlayingTrackWithVote="nowPlayingTrackWithVote" :customMixes="customMixes" :selectedMix="selectedMix" :customMixListIsOpen="customMixListIsOpen" :isTpg="isTpg"
                    :volume="volume" :clientDidSetMuted="clientDidSetMuted" @updateVolume="updateVolume" @toggleCustomMixer="toggleCustomMixer" @skipTrack="skipTrack" @popNowPlayingComment="popNowPlayingComment" @logEvent="logEvent" style="margin-top:-20px;">
                </NowPlaying>

                <Last5 :selectedPlayer="selectedPlayer" :user-info="userInfo" :tracks="lastFiveTracks" :isTpg="isTpg" @logEvent="logEvent" v-if="allowLastFive() == true && userHasOnlinePlayer" style="margin-top:-34px;padding-bottom:10px;">
                </Last5>

                <!-- T233 - (01-14-2022) -->
                <div v-if="selectedPlayer.playerTypeId == 1 || selectedPlayer.playerTypeId == 2">
                  <VolumeControl :volume="volume" :isTpg="isTpg" :clientDidSetMuted="clientDidSetMuted" :volumeIsDisabled="volumeIsDisabled" :maxVolumeIncrements="maxVolumeIncrements" :volumeIndex="volumeIndex" @updateVolume="updateVolume" @updateMute="updateMute" style="padding-bottom:20px;" v-if="userHasOnlinePlayer && userCanUpdateVolume && selectedPlayer.isShutdown != '1'">
                  </VolumeControl>
                </div>
            </div>

            <!-- <custom-mixer class="custom-mixer" v-if="customMixListIsOpen" :isTpg="isTpg" :selectedMix="selectedMix" :customMixes="customMixes" @newMixSelected="newMixSelected"></custom-mixer> -->

        </div>
        <div class="menu-right" :class="{noOnlinePlayers: !userHasOnlinePlayer, menuIsOpen:menuIsOpen, isTpg:isTpg}">
            <div v-if="menuIsOpen == false || !userHasOnlinePlayer">
                <div v-for="menuItem in filteredMenuItems" :key=menuItem.path>
                    <router-link :to="menuItem.path" tag="li" class="menu-item menu-item-right hover" :class="{isTpg:isTpg}">
                        {{ capitlize(menuItem.name) }}
                        <span class="menu-item-chevron" :class="{isTpg:isTpg}"></span>
                    </router-link>
                </div>
            </div>
            <div style="padding-top:5px;padding-left:5px;">
                <a class="midtempo-link-mobile" :class="{isTpg:isTpg}" href="https://www.midtempo.co" target="NEW">Visit midtempo.co</a>
                <a target="NEW" href="https://www.instagram.com/midtempo.co" style="margin-left:7px;margin-top:2px;"><svg class="midtempo-link-svg" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#ffffff"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"></path></svg></a>
            </div>
        </div>

    </nav>
</template>

<script>
import NowPlaying from './NowPlaying.vue';
import Last5 from './Last5.vue';
import ChangePlayer from './ChangePlayer.vue';
import SelectCustomMix from './SelectCustomMix.vue';
import MenuVoteComment from './MenuVoteComment.vue';
import VolumeControl from './VolumeControl.vue';
import Player from '@/player.js'; // T268 (02-15-2022)
import VolumeMapping from '@/volumeMapping.js';

const Querystring = require('querystring');

export default {
  // components: { NowPlaying, , ChangePlayer, , MenuVoteComment,  },
  components: {
    NowPlaying, ChangePlayer, Last5, VolumeControl, SelectCustomMix, MenuVoteComment,
  },
  data() {
    return {
      locationZonesForPicker: {},
      selectedLocation: '',
      selectedLocationZoneID: '',
      accountingServiceOptionID: 28,
      creativeServiceOptionID: 27,
      itOnlyServiceOptionID: 16,
      volumeServiceOptionID: 35,
      userAdminServiceTypeID: '14',
      itModeMenuItems: [
        { name: 'Connectivity', path: '/players' },
        { name: 'Support', path: '/support' },
      ],
      nowPlayingTrackWithVote: {
        id: '',
        code: '',
        title: '',
        duration: '',
        playingAt: '',
        artist: {
          name: ''
        },
        recordLabel: {
          name: ''
        },
        album: {
          name: '',
          cover: ''
        },
        votes: {
          vote: '',
          voteReasonId: '',
          comment: ''
        },
      },
      lastFiveTracks: [],
      refreshNowPlayingInterval: 20, // In seconds
      refreshConnectivityInterval: 600, // In seconds (10 minutes) - T369 (08-01-2022)
      oldTrackCode: '',
      players: [],
      selectedPlayer: {},
      refreshTrackTimer: '',
      refreshConnectivityTimer: '', // T369 - (08-01-2022)
      customMixes: {},
      customMixListIsOpen: false,
      selectedMix: { name: 'Daily Playlists', id: 'auto' }, // Default
      isLoading: false,
      loadingOverlayText: '',
      selectedPlayerRlid: '',
      resetMixModal: '',
      voteReasons: '',
      userHasLocationZones: true,
      filteredMenuItems: '',
      volume: 87,
      canSetVolume: '1',
      isVp: false,
      clientDidSetMuted: false,
      showReturnToDailyButton: false,
      isInitialTrack: true,
      showNowPlayingCommentModal: false,
      showMixModal: false,
      userCanUpdateVolume: false,
      volumeIsDisabled: false, // T700 (08-05-2022)
      maxVolumeIncrements: 0,  // CW-29 (01-11-2023)
      volumeIndex: 0,          // CW-29 (01-11-2023)
    };
  },
  props: ['menuIsOpen',
    'user-info',
    'menu-last-updated',
    'logged-out',
    'user-has-online-player',
    'is-tpg',
    'all-players',
    'location-zones',
    'all-samples',
    'is-loading-remaining-players',
  ],
  setup() {

  },
  mounted() {
    this.buildMenu();
    this.getVoteReasons();
    this.setPlayers();
    //
    // this.doesUserHaveLocationZones();
  },
  methods: {
    logEvent(params) {
      this.$emit('logEvent', params);
    },
    // Update volume
    updateVolume(newVolumeIndex) {
      // console.log("NEW volume index: " + newVolumeIndex); // DEBUG
      const newVolume =  VolumeMapping.getVolumeLevel(newVolumeIndex);
      // console.log("NEW volume value: " + newVolume); // DEBUG

      // Check if volume was actually changed - T369 (08-25-2022)
      if (this.volume == newVolume) {
        return;
      }

      this.setPlayerVolume(this.selectedPlayer.fId(), this.volume); // T700 (08-05-2022) - T700 (08-12-2022) - modified
      this.volumeIsDisabled = true; // T700 (08-05-2022)

      this.volume = newVolume; // set volume to new volume value
      this.volumeIndex = VolumeMapping.getVolumeLevelIndex(parseInt(this.volume)); // SI-278 - (06-30-2023)

      const params = Querystring.stringify({ volume: this.volume });
      this.$http.patch(`/location_zone_player/${this.selectedPlayer.locationZonePlayerId}`, params)
        .then(() => {})
        .catch((error) => console.log(error));
    },
    // If player is muted
    updateMute() {
      if (this.clientDidSetMuted == 1) {
        this.clientDidSetMuted = 0;
      } else {
        this.clientDidSetMuted = 1;
        this.$wkToast('Volume muted');
      }
      const params = Querystring.stringify({ mute: this.clientDidSetMuted });
      this.$http.patch(`/location_zone_player/${this.selectedPlayer.locationZonePlayerId}`, params).then(() => {

      });
    },
    /**
     *load vote reasons
     */
    getVoteReasons() {
      const self = this;
      this.$http.get('/vote/reasons').then((response) => {
        const reasons = response.data;
        self.voteReasons = reasons;
      })
        .catch((error) => console.log(error));
    },
    popNowPlayingComment() {
      this.showNowPlayingCommentModal = true;
      // this.$refs.nowPlayingCommentModal.show();
    },
    saveComment(voteReasonAndComment) {
      // No info, no need to save
      // if (!voteReasonAndComment.selectedReasonID && !voteReasonAndComment.comment) {
      //     return;
      // }

      // Save vote reason
      if (voteReasonAndComment.selectedReasonID) {

        // WSL type - T686 (05-26-2022)
        if (this.selectedPlayer.playerTypeId == '4') {
          const trackWithComment = Querystring.stringify({
            location_zone_player_id: this.selectedPlayer.fId(),
            track_code: voteReasonAndComment.track.code,
            vote_reason_id: voteReasonAndComment.selectedReasonID,
            comment: voteReasonAndComment.comment,
          });
          this.$http.post('/location_zone/vote/reason', trackWithComment).then(() => { });
        } else { // All other Types (physical/virtual/instore)
          const trackWithComment = Querystring.stringify({
            trackCode: voteReasonAndComment.track.code,
            voteReasonId: voteReasonAndComment.selectedReasonID,
            comment: voteReasonAndComment.comment,
          });
          this.$http.post(`/v3/vote/reason/${this.selectedPlayer.playerTypeId}/${this.selectedPlayer.fId()}`, trackWithComment).then(() => { });
        }

        this.nowPlayingTrackWithVote.votes.voteReasonId = voteReasonAndComment.selectedReasonID;
      }

      // Save the comment
      if (voteReasonAndComment.comment && !voteReasonAndComment.selectedReasonID) {

        // WSL type - T686 (05-26-2022)
        if (this.selectedPlayer.playerTypeId == '4') {
          const trackWithComment2 = Querystring.stringify({
            location_zone_player_id: this.selectedPlayer.fId(),
            track_code: voteReasonAndComment.track.code,
            comment: voteReasonAndComment.comment,
          });
          this.$http.post('/location_zone/vote/comment', trackWithComment2).then(() => { });
        } else { // All other Types (physical/virtual/instore)
          const trackWithComment2 = Querystring.stringify({
            trackCode: voteReasonAndComment.track.code,
            comment: voteReasonAndComment.comment,
          });
          this.$http.post(`/v3/vote/comment/${this.selectedPlayer.playerTypeId}/${this.selectedPlayer.fId()}`, trackWithComment2).then(() => { });
        }

        this.nowPlayingTrackWithVote.votes.comment = voteReasonAndComment.comment;
      }
    },
    deleteComment(track) {
      // WSL type - T686 (05-26-2022)
      if (this.selectedPlayer.playerTypeId == '4') {
        this.$http.delete(`/location_zone/vote/comment/${this.selectedPlayer.fId()}/${track.code}`).then(() => { });
        this.$http.delete(`/location_zone/vote/reason/${this.selectedPlayer.fId()}/${track.code}`).then(() => { });
      } else { // All other Types (physical/virtual/instore)
        this.$http.delete(`/v3/vote/comment/${this.selectedPlayer.playerTypeId}/${this.selectedPlayer.fId()}/${track.code}`).then(() => { });
        this.$http.delete(`/v3/vote/reason/${this.selectedPlayer.playerTypeId}/${this.selectedPlayer.fId()}/${track.code}`).then(() => { });
      }

      this.nowPlayingTrackWithVote.votes.comment = '';
      this.nowPlayingTrackWithVote.votes.voteReasonId = '';
    },
    newMixSelected(mix, duration, shouldShuffle) {
      this.selectedMix = mix;

      let playbackDurationInSeconds = null;
      let loop = 0;
      if (mix.id == 'auto') {
        this.loadingOverlayText = 'Please wait while we return to your Daily Playlst. This may take a few moments.';
      } else {
        // Determine whether to loop and the playbackduration in seconds
        if (duration === 'Loop Forever') {
          loop = 1;
          playbackDurationInSeconds = 0;
        } else if (duration === 'Play through once') {
          playbackDurationInSeconds = mix.duration;
        } else {
          const hours = duration.split(' ')[0];
          playbackDurationInSeconds = hours * 60 * 60;
        }
        this.loadingOverlayText = `Please wait while we load ${mix.name} Custom Mix. This may take a few moments.`;
      }

      // Convert from bool to type
      let shuffleIt = '0';
      if (shouldShuffle) {
        shuffleIt = '1';
      }

      const newMix = Querystring.stringify({
        location_zone_player_id: this.selectedPlayer.fId(),
        custom_playlist_id: mix.id,
        use_cache: 'yes',
        loop,
        playback_duration: playbackDurationInSeconds,
        should_shuffle: shuffleIt,
      });

      this.$http.post('/v3/station/switch', newMix).then(() => {
        // intentionally nothing
      });

      const event_data = {
        web_tracking_event_type_id: 7,
        page_name: 'Menu - Now Playing',
        location_zone_player_id: this.selectedPlayer.fId(),
        location_zone_custom_playlist_id: mix.id
      };
      this.$emit('logEvent', event_data);
    },
    skipTrack() {
      this.isLoading = true;
      this.loadingOverlayText = 'Track skipped; Please wait while we load the next track.';

      if (!this.nowPlayingTrackWithVote.id || !this.selectedPlayer.fId()) {
        this.$wkToast('Unable to skip track: track id not found');
        return;
      }

      this.$http.post(`/track/skip/${this.selectedPlayer.fId()}/${this.nowPlayingTrackWithVote.id}`).then(() => {

      });
    },
    returnToDefaultState() {
      this.showMixModal = false;
      this.isLoading = false;
      this.loadingOverlayText = '';
    },
    getCustomMixes() {
      const self = this;
      this.customMixes = {}; // T589 - reflected Jarretts fix - (03-29-2002)
      if (this.selectedLocationZoneID) {
        this.$http.get(`/custom_lists/location_zone/${this.selectedLocationZoneID}`).then((response) => {
          if (response.data && response.data.length > 0) {
            self.customMixes = response.data;
          }
          self.setLastFiveTracks();
        }).catch((response) => {
          console.log(`ERROR GETTING CUSTOM MIXES ${JSON.stringify(response)}`);
        });
      }
    },
    /**
     * Set all players for this user. Only show player in list
     * if it has location_zone_player_data.
     *
     * @set this.players
     */
    setPlayers() {
      this.players = []; // reset

      if (this.allPlayers && this.allPlayers.length > 0) {
        Object.keys(this.allPlayers).forEach(key => {
          if (this.allPlayers[key].isOnline()) {
            this.players.push(this.allPlayers[key]);
          }
        });
      }
      // DEBUG - Display
      // Object.keys(this.allPlayers).forEach(key => {
      //    console.log(this.allPlayers[key]);
      // });
      // Object.keys(this.players).forEach(key => {
      //    console.log(this.players[key]);
      // });

      // Sort by esTitle - T369 (05-20-2022), T369 (08-02-2022)
      // Remove first player since this is the initial selected player from 'first' endpoint call, then sort,
      // then add initial player back to the front of the players array
      if (this.players.length > 1) {
        const firstPlayer = this.players.shift();
        this.players.sort((a, b) => (a.esTitle > b.esTitle) ? 1 : -1);
        this.players.unshift(firstPlayer);
      }

      // Proceed to setting up initial selected player
        this.setInitialPlayer();
    },
    /**
     * If a player id is set in cookie, use that as selected.
     * Otherwise, use the most recent.
     *
     * @param
     * @set this.selectedPlayer
     */
    setInitialPlayer() {
      if (!this.players || !this.players.length) {
        return;
      }

      let selectedPlayerFId = null;
      if (this.getPlayerFIdCookie()) {
        selectedPlayerFId = this.getPlayerFIdCookie();

        // Make sure cookieID is in list of location zones
        let foundMatch = false;
        Object.keys(this.players).forEach(key => {
          if (this.players[key].fId() == selectedPlayerFId) {
            foundMatch = true;
          }
        });

        // If no match,
        if (!foundMatch) {
          if (this.players.length > 0 && this.players[0].fId()) {
            selectedPlayerFId = this.players[0].fId();
          }
        }
      } else if (this.players.length > 0 && this.players[0].fId()) {
        selectedPlayerFId = this.players[0].fId();
      }

      this.setSelectedPlayer(selectedPlayerFId);
    },
    /**
     * Sets this.selectedPlayer used in MainMenu sub-components.
     * Then initiates setLastFiveTracks
     *
     * @param selectedPlayerFId int
     * @set this.selectedPlayer
     */
    setSelectedPlayer(selectedPlayerFId) {
      for (let i = 0; i < this.players.length; i++) {
        if (selectedPlayerFId == this.players[i].fId()) {
          this.selectedPlayer = this.players[i];
          this.setVolumeMapping(this.selectedPlayer); // set selected players volume mapping - CW-29 (01-11-2023)

          this.selectedLocationZoneID = this.selectedPlayer.locationZoneId;
          this.volume = (this.selectedPlayer.volume !== undefined) ? this.selectedPlayer.volume : this.volume; // T369 (08-09-2022) - modified

          //
          // TODO: Frank: where will new setting be for previous 'clientDidSetMuted' and how should we apply the new playerTypeId to replace the below logic? - (01-12-2022)
          //

          this.refreshClientDidSetMuted();
          // Check if VP
          // const { version } = this.selectedPlayer.location_zone_player_data;
          // if (version.includes('VP')) {
          if(this.selectedPlayer.playerTypeId == '2') {
            this.isVp = true;
          } else {
            this.isVp = false;
          }
          // NOTE: added this because of recent changes in T235 (02-17-2022)
          this.nowPlayingTrackWithVote = this.selectedPlayer.currentTrack;
          this.lastFiveTracks = this.selectedPlayer.lastFive;

          return;
        }
      }
    },
    setSelectedMix(selectedListId, current_playlist_name) {
      if (!selectedListId || current_playlist_name.substring(0, 2) == '20') {
        const daily = { name: 'Daily Playlists', id: 'auto' };
        this.selectedMix = daily;
        this.showReturnToDailyButton = false;
      }

      for (let i = 0; i < this.customMixes.length; i++) {
        if (this.customMixes[i].id == selectedListId) {
          this.selectedMix = this.customMixes[i];

          this.showReturnToDailyButton = true;
          return;
        }
      }
    },
    setNowPlayingRefresh() {
      clearInterval(this.refreshTrackTimer);
      this.refreshTrackTimer = setTimeout(() => {
        this.setNowPlayingTrack();
      }, (1000 * this.refreshNowPlayingInterval));
    },
    setNowPlayingTrack() { // T235 (02-16-2022)
      // Make sure we have a selected player
      if (!this.selectedPlayer || !this.selectedPlayer.playerTypeId || !this.selectedPlayer.fId()) return; // T235 - (02-16-2022) - (was .id)

      // this.volume = Number(this.selectedPlayer.volume); // refresh Volume component to display current volume setting - T369 - (06-24-2022)

      const self = this;
      // GET Specific Player by Type and UniqueId -> /v3/player/{{type}}/{{fId}}
      let endpoint = '/v3/player/' + this.selectedPlayer.playerTypeId + '/'  + this.selectedPlayer.fId();
      this.$http.get(endpoint).then((response) => {
        self.setNowPlayingRefresh();
        try {
          const nowPlayingTrack = response.data.data.players.currentTrack;
          // update the selected players attributes with new polling player data
          this.selectedPlayer.update(response.data.data.players);

          // T369 - (07-29-2022)
          // Check if the current player is still online, if the selected player is now offline then refresh players
          // by calling getFirstPlayer() in MainLayout
          if (!this.selectedPlayer.isOnline()) {
              localStorage.removeItem("selectedPlayerFId");
              localStorage.removeItem("selectedPlayerTypeId");
              this.$emit('getFirstPlayer');
              return;
          }

          // T700 (08-05-2022)
          this.checkVolume(this.selectedPlayer);
          this.refreshClientDidSetMuted();

          // this.updatePlayerVotes(); // 05-10-2022, T369 (08-24-2022) - comment-out to reduce calls to the voting endpoint

          // Only update if different
          if (nowPlayingTrack.code != self.nowPlayingTrackWithVote.code || !self.nowPlayingTrackWithVote.code) {
            this.updatePlayerVotes(); // T624 get votes (04-13-2022)
            this.lastFiveTracks = this.selectedPlayer.lastFive; // update last five tracks
            self.nowPlayingTrackWithVote = this.selectedPlayer.currentTrack; // set now playing track with vote
          }
        } catch(error) {
          console.log(`EXCEPTION WHILE UPDATING PLAYER ${JSON.stringify(response)}`);
          return;
        }
      },
      (response) => {
        console.log(`ERROR UPDATING PLAYER ${JSON.stringify(response)}`);
        self.setNowPlayingRefresh();
      });
    },
    setLastFiveTracks() {
      if (!this.selectedPlayer || !this.selectedPlayer.fId()) {
        this.lastFiveTracks = [];
        return;
      }
      this.lastFiveTracks = this.selectedPlayer.lastFive;
      this.setSelectedMix(this.selectedPlayer.currentCustomListId, this.selectedPlayer.currentPlaylistName);
      this.setNowPlayingTrack();
      this.setNowPlayingRefresh();

      if (this.selectedPlayer.currentPlaylistName === 'NO_LIST') {
        this.showReturnToDailyButton = true;
      }
    },
    /**
     * GET the selected player by Type and UniqueId and set this.selectedPlayer with
     * the API response if valid.
     *
     * @param object player (with minimal data)
     */
    updateSelectedPlayer(newPlayer) {
      if(!newPlayer || !newPlayer.playerTypeId || !newPlayer.fId()) return;

      // GET Specific Player by Type and UniqueId -> /v3/player/{{type}}/{{fId}}
      let endpoint = '/v3/player/' + newPlayer.playerTypeId + '/'  + newPlayer.fId();

      this.$http.get(endpoint).then((response) => {
        if (!response.data || !response.data.data || !response.data.data.players) {
          return;
        }

        // create instance of Selected Player
        this.selectedPlayer = new Player(response.data.data.players);
        const playerUniqueId = this.selectedPlayer.fId();
        const playerTypeId = this.selectedPlayer.playerTypeId;

        this.updatePlayerVotes(); // T624 get votes (04-13-2022)

        // // DEBUG
        // console.log('this.selectedPlayer UniqueId: ' + this.selectedPlayer.fId())
        // console.log('this.selectedPlayer: ' + JSON.stringify(this.selectedPlayer));
        this.setVolumeMapping(this.selectedPlayer); // set selected players volume mapping - CW-29 (01-11-2023)
        this.volumeIsDisabled = this.getVolumeIssued(playerUniqueId); // T700 (08-05-2022) - when switching players check if a volume command was issued for the new selected player and enable/disable volume bar accordingly
        this.volume = this.selectedPlayer.volume;
        this.clientDidSetMuted = this.selectedPlayer.clientDidSetMuted;

        this.setPlayerCookies(playerTypeId, playerUniqueId);

        this.selectedLocationZoneID = this.selectedPlayer.locationZoneId;
        this.customMixListIsOpen = false;
        this.isInitialTrack = true;
      },
      (response) => {
        console.log(`ERROR GETTING SELECTED PLAYER ${JSON.stringify(response)}`);
      });
    },
    /*
     * T624 - (04-13-2022)
     * Updated the current selected players track votes.
     */
    updatePlayerVotes() {
      let endpoint = '/v3/votes/zone/' + this.selectedPlayer.locationZoneId + this.buildVoteEndpointParams(this.selectedPlayer);
      this.$http.get(endpoint).then((response) => {
        try {
          this.selectedPlayer.insertVotes(response.data.data.votes);
        } catch(error) {
          console.log(`EXCEPTION WHILE RETRIEVING VOTES FOR PLAYER ${JSON.stringify(response)}`);
        }
      },
      (response) => {
        console.log("ERROR RETRIEVING VOTES FOR PLAYER " + JSON.stringify(response));
      });
    },
    /*
     * T646 - (04-22-2022)
     * Builds the tracks code string for the votes-zone endpoint
     *
     * @param currentPlayer - current player (Player object)
     * @return string
     */
    buildVoteEndpointParams(currentPlayer) {
      if(!currentPlayer
        || !currentPlayer.currentTrack
        || !currentPlayer.currentTrack.code) {
        return "";
      }

      let buildStr = "";
      try {
        const currentTrack = currentPlayer.currentTrack;
        const lastFive = currentPlayer.lastFive ? currentPlayer.lastFive : [];
        buildStr = "?trackCode[]=" + currentTrack['code'];

        Object.keys(lastFive).forEach(key => {
            buildStr += "&trackCode[]=" + lastFive[key]['code'];
        });
      } catch(error) {
        console.log(`EXCEPTION WHILE BUILDING VOTE ENDPOINT PARAMS: error -> ${error}`);
        buildStr = "";
      }

      return buildStr;
    },
    /*
     * T369 - (08-01-2022)
     * Set the connectivity refresh timer interval
     */
    setConnectivityRefresh() {
      clearInterval(this.refreshConnectivityTimer);
      this.refreshConnectivityTimer = setInterval(() => {
        this.setConnectivity();
      }, (1000 * this.refreshConnectivityInterval));
    },
    setConnectivity() {
      // invoke the loadRemainingPlayers() method to uspdate connetivity data
      this.$emit('loadRemainingPlayers');
    },

    getPlayerFIdCookie() {
      if (localStorage.getItem('selectedPlayerFId')) {
        return localStorage.getItem('selectedPlayerFId');
      }
    },
    getPlayerTypeIdCookie() {
      if (localStorage.getItem('selectedPlayerTypeId')) {
        return localStorage.getItem('selectedPlayerTypeId');
      }
    },
    setPlayerCookies(newPlayerTypeId, newPlayerUniqueId) {
      if (Number.isInteger(parseInt(newPlayerTypeId)) && Number.isInteger(parseInt(newPlayerUniqueId))) {
        localStorage.setItem('selectedPlayerTypeId', newPlayerTypeId);
        localStorage.setItem('selectedPlayerFId', newPlayerUniqueId);
      }
    },
    refreshClientDidSetMuted() {
      this.clientDidSetMuted = (this.selectedPlayer.clientDidSetMuted !== undefined) ? this.selectedPlayer.clientDidSetMuted : this.clientDidSetMuted; // T369 (08-09-2022) - modified
    },
    /*
     * T700 (08-05-2022)
     * T700 (08-12-2022) - modified
     *
     * Checks if the volume was updated in the selected player by matching the new volume setting
     * saved in local storage and the value of the selected players volume attribute AND checks if
     * the volume timestamp is expired.
     *
     * @param selectedPlayer - current player (Player object)
     * @return n/a
     */
    checkVolume(selectedPlayer) {
      if (!selectedPlayer) {
        return;
      }
      const playerFId = selectedPlayer.fId();

      // Enter only if a volume command was issued (i.e., volumeIssued-FId session exists)
      if (this.getVolumeIssued(playerFId)) {
        const volumeOld = localStorage.getItem('volumeOld-' + playerFId.toString());
        const volumePlayerData = parseInt(selectedPlayer.volume);
        if (parseInt(volumeOld) != volumePlayerData) {
          this.volume = volumePlayerData;
          this.volumeIndex = VolumeMapping.getVolumeLevelIndex(parseInt(this.volume)); // SI-278 - (06-30-2023)
          this.volumeIsDisabled = false; // sets disableVolumeBar in VolumeControl component
          this.deletePlayerVolume(playerFId);
          this.$wkToast(`Volume has been adjusted`); // T369 (08-12-2022)
        } else if (this.isVolumeTimestampExpired(playerFId)) {
          if (localStorage.getItem('volumeOld-' + playerFId.toString())) {
            const oldVolume = localStorage.getItem('volumeOld-' + playerFId.toString());
            this.volume = parseInt(oldVolume);
            this.volumeIndex = VolumeMapping.getVolumeLevelIndex(parseInt(this.volume)); // SI-278 - (06-30-2023)
            this.volumeIsDisabled = false; // sets disableVolumeBar in VolumeControl component
            this.deletePlayerVolume(playerFId);
            this.$wkToast(`There was a problem setting the Volume`); // T369 (08-12-2022)
          }
        }
      }
    },
    /*
     * T700 (08-05-2022)
     * Retrieve the volume issued value in local storage
     *
     * @param playerFId - players unique identification number
     * @return bool - return true if volumeIssued exists, otherwise return false
     */
    getVolumeIssued(playerFId) {
      return localStorage.getItem('volumeIssued-' + playerFId.toString()) ? true : false;
    },
    /*
     * T700 (08-08-2022)
     * Check if the volume timestamp for this player is expired.
     *
     * @param playerFId - players unique identification number
     * @return bool - return true if volume timestamp is expired, otherwise return false
     */
    isVolumeTimestampExpired(playerFId) {
      if (localStorage.getItem('volumeTimestamp-' + playerFId.toString())) {
        const volumeTimestamp = localStorage.getItem('volumeTimestamp-' + playerFId.toString());
        const diff = Math.floor(Date.now()/1000) - parseInt(volumeTimestamp);

        return diff > 600 ? true : false; // limit = 10 minutes (600 sec)
      }
      return true; // default - timestamp expired
    },
    /*
     * T700 (08-05-2022)
     * Set volume related values in local storage (volumeTimestamp-FId, volumeIssued-FId, volumeOld-FId)
     *
     * @param playerFId - players unique identification number
     * @param oldVolume - previous volume value
     * @return - n/a
     */
    setPlayerVolume(playerFId, oldVolume) {
      if (Number.isInteger(parseInt(playerFId)) && Number.isInteger(parseInt(oldVolume))) {
        localStorage.setItem('volumeTimestamp-' + playerFId.toString(), Math.floor(Date.now()/1000));
        localStorage.setItem('volumeIssued-' + playerFId.toString(), true);
        localStorage.setItem('volumeOld-' + playerFId.toString(), oldVolume);
      }
    },
    /*
     * T700 (08-05-2022)
     * Delete all volume related values in local storage associate to the current players FId (volumeTimestamp-FId, volumeIssued-FId, volumeOld-FId)
     *
     * @param playerFId - players unique identification number
     * @return - n/a
     */
    deletePlayerVolume(playerFId) {
      if (Number.isInteger(parseInt(playerFId))) {
        localStorage.removeItem('volumeTimestamp-' + playerFId.toString());
        localStorage.removeItem('volumeIssued-' + playerFId.toString());
        localStorage.removeItem('volumeOld-' + playerFId.toString());
      }
    },
    /*
     * CW-29 (01-11-2023)
     * Configure the VolumeMapping according to the current players model type
     *
     * @param selectedPlayer - current player (Player object)
     * @return n/a
     */
    setVolumeMapping(selectedPlayer) {
          VolumeMapping.setPlayerModel(selectedPlayer.networkConfig?.model ?? '');
          this.maxVolumeIncrements = (VolumeMapping.getMappingSize() - 1);
          this.volumeIndex = VolumeMapping.getVolumeLevelIndex(parseInt(selectedPlayer.volume));
    },
    capitlize(item) {
      if (item && item[0]) {
        return item[0].toUpperCase() + item.slice(1);
      }
    },
    newTrack(trackWithVote) {
      this.nowPlayingTrackWithVote = trackWithVote;
    },
    allowLastFive() {
      if (!this.userInfo || !this.userInfo.service_options) {
        return false;
      }
      for (let i = 0; i < this.userInfo.service_options.length; i++) {
        if (this.userInfo.service_options[i].service_option_name == 'Last 5 Tracks') {
          return true;
        }
      }

      return false;
    },
    toggleCustomMixer() {
      this.resetMixModal = new Date();
      this.showMixModal = true;
    },
    buildMenu() {
      let showAccounting = false;
      let itMode = false;
      let showCreative = false;
      let showSamples = false;
      let showDocuments = false;

      if (this.userInfo && this.userInfo.has_samples > 0) {
        showSamples = true;
      }
      if (this.userInfo && this.userInfo.has_documents > 0) {
        showDocuments = true;
      }
      if (this.userInfo && this.userInfo.service_options) {
        const serviceOptions = this.userInfo.service_options;
        for (let i = 0; i < serviceOptions.length; i++) {
          if (serviceOptions[i].service_option_id == this.accountingServiceOptionID) {
            showAccounting = true;
          }
          if (serviceOptions[i].service_option_id == this.itOnlyServiceOptionID) {
            itMode = true;
          }
          if (serviceOptions[i].service_option_id == this.creativeServiceOptionID) {
            showCreative = true;
          }
          if (serviceOptions[i].service_option_id == this.volumeServiceOptionID) {
            this.userCanUpdateVolume = true;
          }
        }
      }

      const items = [];

      // If TPG, dont show what's on
      if (!this.isTpg) {
        items.push({ name: "What's on @ Gray V", path: '/whats-on' });
      }

      // If user has samples
      if (showSamples) {
        items.push({ name: 'Samples', path: '/samples' });
      }

      // If user has players
      if (this.allPlayers) {
        items.push({ name: 'Connectivity', path: '/players' });
      }

      // Add locations
      items.push({ name: 'Locations', path: '/locations' });
      // If user has location zones, add other items
      if (showDocuments) {
        items.push({ name: 'Documents', path: '/documents' });
      }

      if (showCreative == true && this.locationZones) {
        items.push({ name: 'Creative', path: '/creative' });
      }

      if (showAccounting == true) {
        items.push({ name: 'Update Payments', path: '/update_payments' });
      }

      // Always have support
      items.push({ name: 'Support', path: '/support' });

      // If user is IT only, then use canned menu
      if (itMode == true) {
        this.filteredMenuItems = this.itModeMenuItems;
        return;
      }

      this.filteredMenuItems = items;
    },
    open() {
      this.isOpen = true;
    },
    close() {
      this.isOpen = false;
    },
    toggle() {
      if (this.isOpen) {
        this.close();
      } else {
        this.open();
      }
    },
    checkServicesAccess(routeName) {
      let redirect = false;

      if (this.userObject) {
        let showAccounting = false;
        let showUsers = false;

        if (!this.userObject.service_options) {
          return;
        }
        const serviceOptions = this.userObject.service_options;
        for (let i = 0; i < serviceOptions.length; i++) {
          if (serviceOptions[i].service_option_id == this.accountingServiceTypeID) {
            showAccounting = true;
          }
          if (serviceOptions[i].service_option_id == this.userAdminServiceTypeID) {
            showUsers = true;
          }
          if (serviceOptions[i].service_option_id == this.itServiceTypeID) {
            this.isItMode = true;
          }
        }

        if (routeName == 'accounting' && showAccounting == false) {
          redirect = true;
        }
        if (routeName == 'users' && showUsers == false) {
          redirect = true;
        }
      }

      if (redirect == true) {
        this.$router.push('/');
      }
    },
  },
  watch: {
    menuLastUpdated() {
      this.setPlayers();
    },
    userInfo() {
      this.buildMenu();

      if (!this.userInfo) {
        clearInterval(this.refreshTrackTimer);
        clearInterval(this.refreshConnectivityTimer); // T369 - (08-01-2022)
      }
    },
    nowPlayingTrackWithVote() {
      // UPDATE last 5 only if new trck
      if (this.oldTrackCode != this.nowPlayingTrackWithVote.code) {
        this.oldTrackCode = this.nowPlayingTrackWithVote.code;

        // New track loaded, make sure overlay is gone.
        this.returnToDefaultState();
      }
    },
    selectedLocationZoneID() {

    },
    loggedOut() {
      // Remove timer
      clearInterval(this.refreshTrackTimer);
      clearInterval(this.refreshConnectivityTimer); // T369 - (08-01-2002)
      clearInterval();
    },
    allSamples() {
      this.buildMenu();
    },
    locationZones() {
      this.buildMenu();

      //
      if (!this.locationZones || this.locationZones.length < 1) {
        this.userHasLocationZones = false;
      }
    },
    allPlayers() {
      this.buildMenu();
      this.setPlayers();
    },
    userHasOnlinePlayer() {
      // console.log("has " + this.userHasOnlinePlayer)
      // this.userHasOnlinePlayer = true;
    },
    selectedPlayer() {
      this.lastFiveTracks = [];
      this.nowPlayingTrackWithVote = {
        id: '',
        code: '',
        title: '',
        duration: '',
        playingAt: '',
        artist: {
          name: ''
        },
        recordLabel: {
          name: ''
        },
        album: {
          name: '',
          cover: ''
        },
        votes: {
          vote: '',
          voteReasonId: '',
          comment: ''
        },
      };
      this.getCustomMixes();
      this.setConnectivityRefresh(); // T369 - (08-01-2002)
    },
  },
  computed: {
    canShuffleOnPlayer() {
      return this.selectedPlayer.can_shuffle;
    },
  },
};

// function sortByKey(array, key) {
//   return array.sort((a, b) => {
//     const x = a[key];
//     const y = b[key];
//     return ((x < y) ? -1 : ((x > y) ? 1 : 0));
//   });
// }
</script>

<style scoped>
.tent {
    background: rgba(72, 70, 77, .9);
    color: white;
    padding: 10px;
    height: 100px;
    padding-bottom: 130px;
    border-radius: 5px;
}

.overlay {
    position: fixed;
    /* Sit on top of the page content */
    display: none;
    /* Hidden by default */
    width: 100%;
    /* Full width (cover the whole page) */
    height: 100%;
    /* Full height (cover the whole page) */
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    /* Black background with opacity */
    z-index: 2;
    /* Specify a stack order in case you're using a different order for other elements */
}

.overlay.isLoading {
    display: block;
}

.overlay p {
    color: white;
    width: 280px;
    margin: 0 auto;
    text-align: center;
    font-weight: normal;
    padding: 10px;
}

.spinner {
    margin: 10px auto;
    width: 45px;
    height: 35px;
    text-align: center;
    font-size: 8px;
}

.spinner>div {
    background-color: #fff;
    height: 100%;
    width: 5px;
    display: inline-block;
    -webkit-animation: sk-stretchdelay 1.2s infinite ease-in-out;
    animation: sk-stretchdelay 1.2s infinite ease-in-out;
}

.spinner .rect2 {
    -webkit-animation-delay: -1.1s;
    animation-delay: -1.1s;
}

.spinner .rect3 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
}

.spinner .rect4 {
    -webkit-animation-delay: -0.9s;
    animation-delay: -0.9s;
}

.spinner .rect5 {
    -webkit-animation-delay: -0.8s;
    animation-delay: -0.8s;
}

@media (min-width:1200px) {
    .midtempo-link-mobile,
    .midtempo-link-svg {
        visibility: hidden;
    }
}

.midtempo-link-mobile {
    color: white;
    text-decoration: none;
    font-weight: bold;
}

.midtempo-link-mobile.isTpg {
    color: white;
}

.midtempo-link-mobile.isTpg:hover,
.midtempo-link-svg.isTpg:hover {
    color: rgba(1, 172, 129, 1);
}

.midtempo-link-mobile:active {
    text-decoration: none;
}

.midtempo-link-mobile:hover {
    color: yellow;
}

@-webkit-keyframes sk-stretchdelay {
    0%,
    40%,
    100% {
        -webkit-transform: scaleY(0.4)
    }
    20% {
        -webkit-transform: scaleY(1.0)
    }
}

@keyframes sk-stretchdelay {
    0%,
    40%,
    100% {
        transform: scaleY(0.4);
        -webkit-transform: scaleY(0.4);
    }
    20% {
        transform: scaleY(1.0);
        -webkit-transform: scaleY(1.0);
    }
}

.noOnlinePlayers {
    margin: 0 auto;
    float: none;
}

.menu-left {
    margin-top: 56px;
}

.menu-right {
    margin-top: 56px;
}

.menu-right.noOnlinePlayers.menuIsOpen {
    clear:left;
    padding-top: 55px;
}
.menu-left.noOnlinePlayers {
    padding-top: 0;
    margin-top: 0;
    padding-bottom: 0;
    margin-bottom: 0;
}

.noOnlinePlayers.menuIsOpen {
    margin-top: 0px;
}

.menu-item-chevron {
    color: black;
}
.router-link-active {
    text-decoration: none;
}
</style>
